import { Action } from "vuex-class-modules";
import AxiosSecureModule from "./axiosSecureModule";
import Axios, { AxiosResponse } from "axios";
import { Log } from "@/plugins/Logging";
export default class MobModule extends AxiosSecureModule {
    @Action
    public async sendMobMessage(payload: {
        lat: string;
        lng: string;
        phone: string;
    }) {
        await this.defineHeaderAxios();
        Axios.post("api/mob/send/", payload)
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    Log.information("Mob Sent!!");
                }
            })
            .catch((error) => {
                Log.error("", error);
            });
    }
}
